import * as React from 'react';
import { useTranslation } from "react-i18next";
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';
import { Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';



const MyAlert = React.forwardRef(function MyAlert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });


const AlertSnackbar = (props) => {

    const {onClose, open, text} = props;

    const { t } = useTranslation();

    const handleClose = () => {
        onClose();
    }
    
    return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical:"top", horizontal:"center" }} >
        <MyAlert onClose={handleClose} severity="warning" sx={{ width: '100%' }}>
            <Stack direction="row" spacing={2}>
                <Typography>{text}</Typography>
                <Button variant="outlined" size="small" sx={{ color: 'white', borderColor: 'white'}} component={Link} to="/alerts">
                        {t("View")}
                </Button>
            </Stack>
        </MyAlert>
    </Snackbar>
    )
}

export default AlertSnackbar;